import { createConfirmation } from "react-confirm";
import DivisionModal from "./DivisionModal";

export const showDivisionModal = createConfirmation(DivisionModal);
